/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Tax_RuleInputs */

const en_reference_dataset_tax_rule = /** @type {(inputs: Reference_Dataset_Tax_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax rules`)
};

/**
* | output |
* | --- |
* | "Tax rules" |
*
* @param {Reference_Dataset_Tax_RuleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_tax_rule = /** @type {((inputs?: Reference_Dataset_Tax_RuleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Tax_RuleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_tax_rule(inputs)
});